import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    constructor(private http: HttpClient) { }

    public get(path: string, data?: any): Observable<any> {
        const params = {};
        if (data) {
            Object.keys(data).forEach((key: string) => params[key] = (data[key] === null || data[key] === undefined) ? '' : data[key]);
        }
        return this.http.get(environment.apiUrl + path, { params });
    }

    public post(path: string, data?: Object | FormData): Observable<any> {
        return this.http.post(environment.apiUrl + path, data);
    }

    public put(path: string, data?: Object | FormData, params?): Observable<any> {
        return this.http.put(environment.apiUrl + path, data, {params});
    }

    public delete(path: string): Observable<any> {
        return this.http.delete(environment.apiUrl + path);
    }

    public downloadGet(path: string, data?: any): Observable<any> {
        return this.http.get(environment.apiUrl + path, { params: data, responseType: 'blob', observe: 'response' });
    }

    public downloadPost(path: string, data?: any): Observable<any> {
        return this.http.post(environment.apiUrl + path, data, { responseType: 'blob', observe: 'response' });
    }

    public upload(path: string, file: File): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.request('put', environment.apiUrl + path, { body: formData, reportProgress: true, observe: 'events' });
    }
}
